<template>
  <v-col cols="5">
    <h3 class="ml-2">基本情報</h3>
    <v-form ref="productForm" style="width: 100%">
      <div>
        <v-text-field
          v-model="product.identificationCode"
          class="mb-3"
          label="商品コード"
          required
          hint="商品を管理するためのコードです。一意となるよう、任意の文字をご入力して下さい。"
        >
          <template v-slot:label>
            <InputLabel label-name="商品コード" />
          </template>
        </v-text-field>
      </div>
      <div>
        <v-text-field
          v-model="product.name"
          class="mb-3"
          label="商品名"
          :rules="[presenceValidation]"
          required
        >
          <template v-slot:label>
            <InputLabel label-name="商品名" :required="true" />
          </template>
        </v-text-field>
      </div>

      <v-row>
        <v-col cols="3">
          <v-select
            v-model="product.isTaxIncluded"
            class="mb-3"
            :items="taxIncludedSelectItems"
            :rules="[presenceValidation]"
            required
          >
            <template v-slot:label>
              <InputLabel label-name="税表示" :required="true" />
            </template>
          </v-select>
        </v-col>
        <v-col cols="9">
          <v-text-field
            v-model="product.price"
            class="mb-3"
            type="number"
            prefix="¥"
            label="値段"
            required
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <v-textarea
            v-model="product.description"
            class="mb-3"
            label="詳細説明"
            required
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <v-alert
            dense
            type="warning"
          >商品記事で既に使っている商品を非公開にした場合、その記事も自動的に非公開になります。また、商品紹介アイテムは非表示になります。
          </v-alert>
          <v-switch
            v-model="product.published"
            class="mb-3"
            label="公開する"
            required
          />
        </v-col>
      </v-row>
    </v-form>
  </v-col>
</template>

<script>
import InputLabel from '@/components/commons/formParts/inputLabel'
import formValidationUtils from '@/mixins/form_validation_utils'

export default {
  name: 'ProductForm',
  components: { InputLabel },
  mixins: [formValidationUtils],
  props: {
    product: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      taxIncludedSelectItems: [
        { text: '税込', value: true },
        { text: '税抜', value: false }
      ]
    }
  }
}
</script>
